<template>
  <div style="padding-top:30px">
      <div class="success" >
          <div class="tips">{{data.params.tips}}</div>
     <img :src="oss+data.style.icon" alt="" style="width:275px;height:246px">
    <div class="buttom" >
      <div class="button" :style="'background-color:'+data.style.color">前往会员中心</div>
    </div>
  </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "success",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];

    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.success {
  width:320px;
  height:380px;
  margin: 0 auto;
  background-color: #404459 ;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  padding-top: 32px;
  .tips{
      text-align: center;
      font-size: 24px;
      font-weight: 800;
      color: #DAB291;;
  }
  img{
    display: block;
    margin: 0 auto;
  }
    .button{
      width: 150px;
      height: 44px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin: 0 auto ;
      line-height: 44px;
      text-align: center;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #916022;
background: linear-gradient(270deg, #F8DDB9 0%, #DAB291 100%);
      border-radius: 50px;
      margin-top: 10px;
    }
}
</style>